<template>
  <div class="personal-fence-show">
    <div class="name">
      <span class="title">{{$t('supervise.fenceName')}}:</span>
      <span class="content-fence">{{item.name}}</span>
    </div>
    <!-- <a-divider class="divider" /> -->
    <div class="mode">
      <span class="title">{{$t('supervise.forbidType')}}:</span>
      <span class="content-fence">{{item.opt === 1 ? $t('global.forbidIn') : $t('global.forbidOut')}}</span>
    </div>
    <!-- <a-divider class="divider" /> -->
    <div class="time">
      <span class="title">{{$t('supervise.timeOption')}}:</span>
      <span class="content-fence">{{startTime}}</span>
      <span class="content-fence">~</span>
      <span class="content-fence">{{endTime}}</span>
    </div>
    <PersonalFenceMap  :idName="index" :opt="item.opt" :mapData="item" fenceStatu="show" />
    <a-button class="btn" type="primary" @click="modifFence(index)">{{$t('supervise.editFence')}}</a-button>
    <a-button class="btn" type="danger" @click="deleteFence(item.id)">{{$t('supervise.deleteFence')}}</a-button>
  </div>
</template>
<script>
import PersonalFenceMap from '@components/common/PersonalFenceMap'
import moment from 'moment'
export default {
  components: {
    PersonalFenceMap
  },
  data () {
    return {
      startTime: '',
      endTime: '',
    }
  },
  props: {
    item: {
      required: true,
      type: Object
    },
    index: {
      required: true
    }
  },
  methods: {
    modifFence (index) {
      // console.log(id)
      this.$emit('editFence', index)
    },
    deleteFence (id) {
      // console.log(id)
      this.$emit('deleteFence', id)
    },
    formatTime () {
      if (this.item.acl && this.item.acl.length > 0) {
        let [start, end] = this.item.acl[0].split('~')
        // console.log(start, end)
        if (start && end) {
          // this.startTime = moment(parseInt(start)).format('HH:mm')
          this.startTime = moment(parseInt(start) * 1000).isValid() ? moment(parseInt(start) * 1000).format('HH:mm') : '00:00'
          // console.log(this.startTime)
          this.endTime = moment(parseInt(end) * 1000).isValid() ? moment(parseInt(end) * 1000).format('HH:mm') : '23:59'
          // console.log(this.endTime)
        } 
      } else {
        this.startTime = '00:00'
        this.endTime = '23:59'
      }
    }
  },
  created () {
    this.formatTime()
  }
}
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.personal-fence-show {
  font-size: 15px;
  // color: rgb(238, 232, 232);
  // background-color: rgba(10, 50, 102, 0.644);
  // box-shadow: 1px 1px 3px #ccc;
  // padding: 10px;
  box-sizing: border-box;
  .btn {
    margin-right: 15px;
    width: 20%;
  }
  div {
    margin-bottom: 10px;
    padding-bottom: 3px;
    border-bottom: 1px solid #ccc;
    .title {
      // color: rgb(194, 189, 189);
      color: @heading-color;
      margin-right: 15px;
      margin-left: 5px;
    }
    .content-fence {
      color: rgb(73, 72, 72);
    }
  }
}
</style>
